/**
 * WFS/WMS API通信 レイヤ/CQLパラメータ格納クラス
 */
export class CqlParameter {
  /**
   *  レイヤ名
   */
  _layerName: string;

  /**
   *  CQLパラメータ
   */
  _cqlParameter: string;

  /**
   *  CQLパラメータ
   */
  constructor(layerName: string, cqlParameter: string) {
    this._layerName = layerName;
    this._cqlParameter = cqlParameter;
  }
}
